/**
 * `SharedData`: a notification channel, held per structure+instance by
 * `AppData`.
 *
 * Everything mounted on the same instance shares one channel, so a writer can
 * notify subscribers without holding a reference to any of them.
 */

export class SharedData {
    dataWatchers: (() => void)[] = [];

    watch(watchFunc: () => void): () => void {
        this.dataWatchers.push(watchFunc);
        return () => {
            this.dataWatchers = this.dataWatchers.filter((w) => w !== watchFunc);
        };
    }

    notifyWatchers(): void {
        this.dataWatchers.forEach((w) => w());
    }
}
